import React from 'react'
import ReactDOM from 'react-dom'
import './main.css'
import Picker from './views/Picker'

ReactDOM.render(
  <React.StrictMode>
    <Picker />
  </React.StrictMode>,
  document.getElementById('root')
)
